import _values from 'lodash/values';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Glyph from 'kepler/lib/components/Glyph';

// Helper
import * as shape from '../constants/PropTypesShapes';

class TopicBreadCrumb extends Component {
  // Check the value for layer data
  isEmpty() {
    const values = _values(this.props.items);
    return values.every(value => value === '');
  }

  // Handle each breadcrumb item click event
  handleClick(item) {
    this.props.onClick({ item });
  }

  // Filter for mobile version
  mobileItemFilter() {
    const items = this.props.items;
    const length = Object.keys(items).length;

    // Only take the latest layer topic name for breadcrumb
    if (this.props.mobile) {
      for (let i = length; i > 0; i -= 1) {
        const key = `${this.props.layerName}${i}`;
        if (items[key]) {
          const obj = {};
          obj[key] = items[key];
          return obj;
        }
      }
    }
    return items;
  }

  // Render Each Breadcrumb item
  renderBreadCrumb(item) {
    /**
     * item is array to store breadcrumb info
     * index 0: topic layer: 'layer1'/'layer2'/'layer3'
     * index 1: topic name
     */
    if (item[1] === '' || item[0] === '') {
      return null;
    }
    return (
      <span className="topic-breadcrumb-item" key={item[0]}>
        <span // eslint-disable-line jsx-a11y/no-static-element-interactions
          className="topic-breadcrumb-message"
          role="button"
          tabIndex="0"
          onClick={() => this.handleClick(item)}
        >
          {item[1]}
        </span>
        <Glyph icon="icon-arrow-right-small" className="accordion-icon" />
      </span>
    );
  }

  render() {
    if (this.isEmpty()) {
      return null;
    }
    return (
      <div className={this.props.className}>
        {Object.entries(this.mobileItemFilter()).map(item => this.renderBreadCrumb(item))}
      </div>
    );
  }
}

TopicBreadCrumb.propTypes = {
  className: PropTypes.string,
  items: PropTypes.shape(shape.TOPICLAYERS),
  onClick: PropTypes.func,
  mobile: PropTypes.bool,
  layerName: PropTypes.string,
};

TopicBreadCrumb.defaultProps = {
  className: 'topic-breadcrumb-container',
  items: {},
  onClick: () => {},
  mobile: false,
  layerName: 'layer',
};

export default TopicBreadCrumb;
